import { useCallback } from "react";
import { CustomModal } from "../../../../../lib/CustomModal";
import { RequestsForm } from "./RequestsForm";

type RequestsModalProps = {
  contractNumber: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const RequestsModal = ({
  contractNumber,
  open,
  setOpen,
}: RequestsModalProps) => {
  const close = useCallback(() => setOpen(false), [setOpen]);

  return (
    <CustomModal
      isModalOpen={open}
      setIsModalOpen={setOpen}
      titleText="Request Payoff Quote"
      headerClass="processing-print-modal--header"
      modalClass="processing-print-modal"
      width={450}
      destroyOnClose
    >
      <RequestsForm contractNumber={contractNumber} close={close} />
    </CustomModal>
  );
};
